import React from 'react';
import { Svg } from 'components/icons/Svg';

export const IconNewIndicator = props => (
  <Svg {...props}>
    <circle cx="12" cy="12" r="4" fill="currentColor" />
  </Svg>
);
